import React from 'react';
import useEffect from '@/util/hook/useEffect';
import useRef from '@/util/hook/useRef';
import useState from '@/util/hook/useState';
import { PALETTE_COLORS } from '@/constant/unit/color';
import { S } from './style';
import { CheckLight, Copy as CopyIcon } from '../../atom/Icon';
const IS_COPIED_DURATION_SECOND = 1.8;
const useResetIsCopied = ({ isCopied, setIsCopied, }) => {
    const timer = useRef(null);
    useEffect(() => {
        if (isCopied) {
            if (timer.current)
                clearTimeout(timer.current);
            timer.current = setTimeout(() => {
                setIsCopied(false);
            }, IS_COPIED_DURATION_SECOND * 1000);
        }
        return () => {
            if (timer.current)
                clearTimeout(timer.current);
        };
    }, [isCopied]);
};
const handleCopy = async ({ isCopied, content, setIsCopied, }) => {
    if (isCopied)
        return;
    try {
        await navigator.clipboard.writeText(content);
        setIsCopied(true);
    }
    catch (err) {
        // currently we do nothing when copy failed
    }
};
export default function Copy({ content }) {
    const [isCopied, setIsCopied] = useState(false);
    useResetIsCopied({
        isCopied,
        setIsCopied,
    });
    return (<S.Layout>
      {content}
      <S.LayoutIcon onClick={() => handleCopy({
            content,
            isCopied,
            setIsCopied,
        })}>
        {isCopied ? (<CheckLight size='20px' color={PALETTE_COLORS.NEUTRAL_900}/>) : (<CopyIcon size='20px' color={PALETTE_COLORS.NEUTRAL_900}/>)}
      </S.LayoutIcon>
    </S.Layout>);
}
